import { InterfaceAPI } from '../../../api/files/InterfaceAPI';

export class InterfacesCommand {
    getAll(providerId, successCallback, errorCallback) {
        const apiResult = InterfaceAPI.list(providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Interfaces");
            }
        });
    }

    getAllTransportAuthority(successCallback, errorCallback) {
        const apiResult = InterfaceAPI.listTransportAuthority();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Interfaces");
            }
        });
    }

    saveTransportAuthority(data, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(0 === data.id) {
            apiResult = InterfaceAPI.createTransportAuthority(data);
            successMessage = "Interface criada com sucesso";
        }
        else {
            apiResult = InterfaceAPI.updateTransportAuthority(data.id, data);
            successMessage = "Interface editada com sucesso";
        }
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback(successMessage);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    deleteTransportAuthority(dataId, successCallback, errorCallback) {
        const apiResult = InterfaceAPI.deleteTransportAuthority(dataId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Interface eliminada com sucesso");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    uploadImageTransportAuthority(image, successCallback, errorCallback) {
        const apiResult = InterfaceAPI.uploadImageTransportAuthority(image);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a carregar a Imagem");
            }
        });
    }
}
